import React from "react";
import cevi from "../../Images/Navbar/KLExCEVI.webp";
import { Link, useLocation } from "react-router-dom";
import "../../Stylesheets/Navbar.css";
import kle_logo from "../../Images/Navbar/Kle.webp";

function NavbarTrial() {
  const location = useLocation();
  return (
    <>
      <nav
        className="navbar fixed-top navbar-expand-lg shadow-sm bg-white"
        style={{
          fontWeight: "500",
        }}
      >
        <div className="container ">
          <Link
            className="img-fluid navbar-brand rounded-2 "
            to={location.pathname === "/" ? "https://kletech.ac.in/" : "/" } 
            // target="_blank"
            // rel="noopener noreferrer" 
            style={{ 
              backgroundColor: "white",
            }}
          >
            {" "}
            {/* <img
              src={location.pathname == "/" ? kle_logo : cevi}
              className=""
              alt="CEVI"
              height="50px"
              width="100%"
            /> */}
            <img
            src={location.pathname === "/" ? kle_logo : cevi}
            className={`logo ${location.pathname === "/" ? "kle-logo" : "cevi-logo"}`}
            alt="CEVI"
            height="50px"
            width="100%"
          />
          </Link>
          
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarNav"
          >
            <ul className="navbar-nav nav-underline gap-3">
              <li className="nav-item">
                <Link
                  className={`nav-link  ${
                    location.pathname === "/research" ||
                    location.pathname === "/research/2d" ||
                    location.pathname === "/research/3d" ||
                    location.pathname === "/research/multimodal"
                      ? "active fw-semibold p-0 pt-2 pb-1"
                      : "p-0 pt-2 pb-1"
                  }`}
                  to="/research"
                >
                  Research
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location.pathname === "/projects" ||
                    location.pathname ===
                      "/projects/underwater_archaeological_site" ||
                    location.pathname === "/projects/hampi_reconstruction" ||
                    location.pathname === "/projects/vaidya" ||
                    location.pathname === "/projects/shape-representation"
                      ? "active fw-semibold p-0 pt-2 pb-1"
                      : "p-0 pt-2 pb-1"
                  }`}
                  to="/projects"
                >
                  Projects
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link  ${
                    location.pathname === "/publications"
                      ? "active fw-semibold p-0 pt-2 pb-1"
                      : "p-0 pt-2 pb-1"
                  }`}
                  aria-current="page"
                  to="/publications"
                >
                  Publications
                </Link>
                {/* <a className="nav-link rounded-5 bar" href="http://localhost/cevi-website/publications.php">Publications</a> */}
              </li>

              <li className="nav-item">
                <Link
                  className={`nav-link  ${
                    location.pathname === "/dataset" ? "active fw-semibold p-0 pt-2 pb-1" : " p-0 pt-2 pb-1"
                  }`}
                  to="/dataset"
                >
                  Datasets
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location.pathname === "/team" ? "active fw-semibold p-0 pt-2 pb-1" : " p-0 pt-2 pb-1"
                  }`}
                  to="/team"
                >
                  Team
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link
                  className={`nav-link rounded-5 bar ${
                    location.pathname === "/career" ? "active fw-bold" : ""
                  }`}
                  to="/career"
                >
                  Career
                </Link>
              </li> */}
              <li className="nav-item">
                <Link
                  className={`nav-link  ${
                    location.pathname === "/aboutus" ? "active fw-semibold p-0 pt-2 pb-1" : "p-0 pt-2 pb-1"
                  }`}
                  to="/aboutus"
                >
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link  ${
                    location.pathname === "/contact" ? "active fw-semibold p-0 pt-2 pb-1" : "p-0 pt-2 pb-1"
                  }`}
                  to="/contact"
                >
                  Contact Us
                </Link>
              </li>
            
            </ul>
          </div>
        </div>

      </nav>
    </>
  );
}

export default NavbarTrial;
